import { notification } from 'antd'
import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDeleteEventPayload } from '@app-store/slices/events/delete'

interface TaskAction extends Action {
    payload: IDeleteEventPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.events.delete

function* deleteEventsSagaTask({ payload }) {
    try {
        const response = yield axios.delete(`/event/${payload.eventId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Event deleted successfully.'
            })
            yield payload.sagaCB?.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* deleteEventSaga(): any {
    yield takeLatest<TaskAction>(onRequest, deleteEventsSagaTask)
}

export default deleteEventSaga
